export default "__VITE_ASSET__ldmWIlKv__"